<template>
    <a-modal id="deleteModal" :footer="null" :closable="false" :header="null" :visible="true">
        <div class="delete-modal-cancel" @click="handleCancel">
            <span class="md-icon" style="color: #ec4b1d; cursor: pointer">cancel</span>
        </div>
        <div class="delete-modal-image">
            <DeleteModalIcon style="width: 400px; max-height: 200px" />
        </div>
        <p class="delete-modal-text">{{ description }}</p>
        <div class="delete-modal-slot">
            <slot></slot>
        </div>
        <div class="delete-modal-btn" v-if="modalBtnVisible">
            <button class="push-btn-give-up" @click="handleCancel">
                {{ btnCancelText }}
            </button>
            <button class="push-btn" @click="handleConfirm">
                {{ btnoktext }}
            </button>
        </div>
    </a-modal>
</template>
<script>
import DeleteModalIcon from "../../Chatbot/pages/integrations/svg/DeleteModalIcon.vue";

export default {
    name: "DeleteModal",
    components: { DeleteModalIcon },
    props: {
        description: {
            type: String,
            default: "",
        },
        btnoktext: {
            type: String,
            default: "Confirm",
        },
        btnCancelText: {
            type: String,
            default: "Cancel",
        },
        modalBtnVisible: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        handleCancel() {
            this.$emit("cancel");
        },
        handleConfirm() {
            this.$emit("confirm");
        },
    },
};
</script>
<style scoped lang="scss">
#deleteModal {
    .delete-modal-cancel {
        float: inline-end;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 30px;
        margin-top: -10px;
    }

    .delete-modal-image {
        display: flex;
        margin-bottom: 30px;
        margin-left: 25px;
    }

    .delete-modal-text {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #181c32;
        margin-bottom: 20px;
        text-align: center;
    }

    .delete-modal-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 50px;

        .push-btn {
            background: #ec4b1d;
            border: none;
            outline: none;
            color: #ffffff;
            font-size: 14px;
            font-weight: 500;
            padding: 10px 20px;
            border-radius: 4px;
        }

        .push-btn-give-up {
            background: transparent;
            border: 1px solid #ec4b1d;
            outline: none;
            color: #ec4b1d;
            font-size: 14px;
            font-weight: 500;
            padding: 10px 20px;
            border-radius: 4px;
        }
    }
    .delete-modal-slot{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
    }
}
</style>
